module.exports = __webpack_public_path__ + "img/no_user_photo.b4a10a9b.svg";